import React from "react";
import { useActiveAlarmProfileTitleAlarmListHook } from "./use-active-alarm-profile-title-alarm-list-hook";
import { SubTitle } from "../sub-title/sub-title";

export const ActiveAlarmProfileTitleAlarmList = () => {
  const { profileName } = useActiveAlarmProfileTitleAlarmListHook();

  return <div>{profileName && <SubTitle text={profileName} />}</div>;
};
